import './polyfills';
import {configure} from 'mobx'
import {
    ApplicationStartupConfigurationsReader
} from './app-react/app-bootstrap/application-startup-configurations-reader/application-startup-configurations-reader';
import {SdkHooksProvider} from './app-react/app-bootstrap/sdk-initializer/sdk-hooks-provider';
import {SdkInitializer} from './app-react/app-bootstrap/sdk-initializer/sdk-initializer';
import {ServiceFactory} from './app-react/services/service-factory';
import {renderApp} from './app-react/components/app/app.component';
import {LauncherOverridesReader} from './app-react/app-bootstrap/launcher-overrides-reader/launcher-overrides-reader';
import {InMemoryLocalStorageService} from './app-react/services/storage/in-memory-local-storage.service';
import {StorageService} from './app-react/services/storage/storage.service';
import {IStorageService} from './app-react/services/storage/storage.service.interface';
import {ILoggerService} from './app-react/services/logger/logger.service.interface';
import {ConsoleLoggerService} from './app-react/services/logger/console-logger.service';
import {WindowService} from './app-react/services/window/window.service';
import {HttpService} from './app-react/services/http/http.service';
import {DomService} from './app-react/services/dom/dom.service';
import engLang from './settings/configuration/languages/eng';

import {B2CFrameworkLoader} from './app-react/app-bootstrap/b2c-framework-loader/b2c-framework-loader';
import {DEFAULT_CONFIGS} from './settings/configuration/config';
import {selectTheme} from './app-react/themes/select-theme';
import {ILanguageData} from './app-react/services/language/language.service.interface';
import {ALL_CONFIGS_KEY} from "./app-consts";


configure({
    enforceActions: 'observed'
});


let createStorage = function(logger: ILoggerService): IStorageService {
    try {
        let lsData = '__orbit_check_local_storage__';
        localStorage.setItem(lsData, lsData);
        localStorage.removeItem(lsData);
        return new StorageService(logger);
    }
    catch (e) {
        logger.error('localStorage is not available!');
        return new InMemoryLocalStorageService(logger);
    }

};


async function getLanguageData(languageIso3: string, logger: ILoggerService): Promise<ILanguageData> {
    try {
        let languageDataModule = await import(/*webpackChunkName: "language" */`./settings/configuration/languages/${languageIso3.toLowerCase()}`);
        return languageDataModule.default;
    } catch (err) {
        logger.error(`Failed to load language ${languageIso3}`, err);
        return engLang;
    }

}

export async function startApplication(): Promise<void> {
    let windowService = new WindowService();
    let domService = new DomService();
    let httpService = new HttpService();
    let loggerService = new ConsoleLoggerService(windowService.getGlobalProperty(ALL_CONFIGS_KEY) && windowService.getGlobalProperty(ALL_CONFIGS_KEY).sdk && windowService.getGlobalProperty(ALL_CONFIGS_KEY).sdk.debug);
    let storageService = createStorage(loggerService);

    let sdkHooksProvider = new SdkHooksProvider();
    let launcherOverridesReader = new LauncherOverridesReader(storageService, loggerService);

    let configurationsReader = new ApplicationStartupConfigurationsReader(DEFAULT_CONFIGS,
        windowService,
        launcherOverridesReader,
        httpService,
        loggerService);


    let appConfigs = await configurationsReader.readApplicationConfigurations();

    const languageData = await getLanguageData(appConfigs.b2c.language.iso3, loggerService);

    let theme = await selectTheme({
        themeName: appConfigs.orbit.config.theme.name,
        brandName: appConfigs.brandName,
        serverPath: appConfigs.orbitServer,
        configurationPath: appConfigs.configurationPath,
        window: windowService,
        storage: storageService
    });

    await new B2CFrameworkLoader(launcherOverridesReader, appConfigs.b2c.language.iso2, loggerService).loadB2CFramework();

    await new SdkInitializer(appConfigs, sdkHooksProvider, launcherOverridesReader, windowService, theme, loggerService).init();

    const services = new ServiceFactory(sdkHooksProvider, loggerService, storageService, windowService, domService, httpService, theme, appConfigs, languageData);

    window['getMarketingData'] = function (dl, promo) {
        return window['orbit'].getMarketingData(dl, promo);
    };

    renderApp(services);
}
